import { useQuery } from '@tanstack/react-query';
import supabaseClient from '@/api/supabaseClient.ts';

const useProducts = (enabled: boolean = true, type?: string) => {
  return useQuery({
    queryKey: ['products', type],
    queryFn: () => getProducts(type),
    enabled,
    staleTime: 1000 * 60 * 5,
  });
};

export default useProducts;

async function getProducts(type?: string) {
  let query = supabaseClient.from('products').select('*').order('price', { ascending: true });

  if (type !== undefined) {
    query = query.eq('type', type);
  }

  const { data, error } = await query;

  if (error) throw new Error(error.message);
  return data ?? [];
}
